import { useCallback, useEffect } from 'react';
import { IButtonActionExecAsyncService } from '../IButtonAction';
import { IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps';
import { useExecAsyncServiceAction } from './useExecAsyncServiceAction';

export function ButtonActionExecAsyncServiceLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionExecAsyncService>,
) {
  const {
    action,
    buttonWidgetOptions,
    onClickSubject,
    widget,
    index,
    messageApi,
  } = props;

  const {
    serviceId,
    inputs,
    enableRequestMessage,
    enableSuccessMessage,
    requestMessage,
    successMessage,
  } = action;

  const handleAsyncAction = useExecAsyncServiceAction({
    basePath: buttonWidgetOptions.name,
    serviceId,
    inputs,
    widget,
    index,
    messages: {
      messageApi,
      enableRequestMessage,
      enableSuccessMessage,
      requestMessage,
      successMessage,
    },
  });

  const handleAction = useCallback(() => {
    handleAsyncAction();
  }, [handleAsyncAction]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
